/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const es_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const de_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const nl_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const fr_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const it_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const pt_br2_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const pt_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const ja_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

const zh_od_ngul_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ng/µL`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_ngul_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_ngul_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_ngul_label", locale)
	if (locale === "en") return en_od_ngul_label(inputs)
	if (locale === "es") return es_od_ngul_label(inputs)
	if (locale === "de") return de_od_ngul_label(inputs)
	if (locale === "nl") return nl_od_ngul_label(inputs)
	if (locale === "fr") return fr_od_ngul_label(inputs)
	if (locale === "it") return it_od_ngul_label(inputs)
	if (locale === "pt-BR") return pt_br2_od_ngul_label(inputs)
	if (locale === "pt") return pt_od_ngul_label(inputs)
	if (locale === "ja") return ja_od_ngul_label(inputs)
	return zh_od_ngul_label(inputs)
};